import { inject, Injectable } from '@angular/core';
import { CanActivate, CanMatch, Router, UrlTree } from '@angular/router';

import { AuthFacade } from './auth.facade';

@Injectable({ providedIn: 'root' })
export class ModellerGuard implements CanActivate, CanMatch {
  private _authFacade = inject(AuthFacade);
  private _router = inject(Router);

  canActivate(): boolean | UrlTree {
    return this._authFacade.isAdmin() || this._authFacade.isModeller() ? true : this._router.parseUrl('');
  }

  canMatch(): boolean | UrlTree {
    return this._authFacade.isAdmin() || this._authFacade.isModeller() ? true : this._router.parseUrl('');
  }
}
